export default __webpack_public_path__ + "static/stats-light-background-e79cab01a759412f28186151b828309e.png";